var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnQna = function SvgIcnQna(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8524 12.6225L14.1449 14.9925C14.2199 15.615 13.5524 16.05 13.0199 15.7275L9.87738 13.86C9.53238 13.86 9.19489 13.8375 8.86489 13.7925C9.41989 13.14 9.74989 12.315 9.74989 11.4225C9.74989 9.29249 7.90489 7.56752 5.62489 7.56752C4.75489 7.56752 3.95239 7.815 3.28489 8.25C3.26239 8.0625 3.25488 7.87499 3.25488 7.67999C3.25488 4.26749 6.21738 1.5 9.87738 1.5C13.5374 1.5 16.4999 4.26749 16.4999 7.67999C16.4999 9.70499 15.4574 11.4975 13.8524 12.6225Z",
    stroke: "currentcolor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.4233C9.75 12.3158 9.42001 13.1409 8.86501 13.7934C8.12251 14.6934 6.945 15.2708 5.625 15.2708L3.6675 16.4333C3.3375 16.6358 2.9175 16.3583 2.9625 15.9758L3.15 14.4984C2.145 13.8009 1.5 12.6833 1.5 11.4233C1.5 10.1033 2.205 8.94084 3.285 8.25084C3.9525 7.81584 4.755 7.56836 5.625 7.56836C7.905 7.56836 9.75 9.29332 9.75 11.4233Z",
    stroke: "currentcolor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnQna, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_qna.6e5fcb25.svg";
export { ForwardRef as ReactComponent };